var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mt-2", attrs: { flat: "" } },
    [
      _vm.billingLinkWarning
        ? _c(
            "v-alert",
            {
              staticClass: "mb-2",
              attrs: { type: "warning", dense: "", text: "" },
            },
            [_vm._v(" " + _vm._s(_vm.billingLinkWarning) + " ")]
          )
        : _vm._e(),
      _c(
        "form-data",
        {
          ref: "normalHourReference",
          attrs: { references: _vm.formReferences, model: _vm.hourObj },
          on: {
            "update:references": function ($event) {
              _vm.formReferences = $event
            },
          },
        },
        [
          _c("template", { slot: "section-top" }),
          _c(
            "template",
            { slot: "extraDetails" },
            [
              _vm.flexEngineLine
                ? _c(
                    "v-row",
                    { staticClass: "mx-0 px-1 pb-1", attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6", sm: "4", md: "3" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "auto",
                              readonly: "",
                              label: _vm.$t("message.flex.overtime"),
                              value: _vm.overtimeRateLabel,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6", sm: "4", md: "3" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "auto",
                              readonly: "",
                              label: _vm.$t("message.flex.flexChoice"),
                              value: _vm.flexChoiceLabel,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.canDecideFlexChoice
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4", md: "3" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    outlined: "",
                                    block: "",
                                    id: "flexDecideNow",
                                  },
                                  on: { click: _vm.decideFlexChoiceNow },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.flex.decideNow"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c("flex-choice-dialog", {
        attrs: { summary: _vm.flexChoiceSummary },
        on: { chosen: _vm.onFlexChoiceChosen, closed: _vm.onFlexChoiceClosed },
        model: {
          value: _vm.showFlexChoiceDialog,
          callback: function ($$v) {
            _vm.showFlexChoiceDialog = $$v
          },
          expression: "showFlexChoiceDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }